// @flow
import React from 'react';
import { differenceInDays } from 'date-fns';
import { Text } from 'primitive-components';

import Banner from '../ui/Banner';
import SwitchBanner from './SwitchBanner';

const currentPageToBannerText = {
  balanceSheet:
    'Your Balance Sheet shows exactly how much money your business owns ' +
    'and owes—so you can better understand your overall financial health.',
  incomeStatement:
    'Revenue, expenses, profit—the power trio. Your Income Statement shows ' +
    'how much cash you earn, spend, and gain in any given time period.',
  summary:
    'The Reports section includes clear financial statements and intuitive visual ' +
    'reports that let you understand your financials at-a-glance.',
  accounts:
    'The Accounts section shows every account you’ve connected to Bench. ' +
    'If you haven’t set anything up, get started below! After that, your bookkeeper ' +
    'will import and categorize your business transactions.',
  documents:
    'Occasionally your bookkeeper will ask for a little something extra from you—like ' +
    'receipts or statements. Any documents you upload or email to your team appear below.',
};

const currentPageToBoldBannerText = {
  balanceSheet: 'Know what you have to work with.',
  incomeStatement: 'See how your money’s moving.',
  summary: 'Keep on top of your finances.',
  accounts: 'Introduce us to your accounts.',
  documents: 'Every document in one place.',
};

const currentPageToLocalStorageKey = {
  balanceSheet: 'isBalanceSheetBannerVisible',
  incomeStatement: 'isIncomeStatementBannerVisible',
  summary: 'isSummaryBannerVisible',
  accounts: 'isAccountsBannerVisible',
  documents: 'isDocumentsBannerVisible',
};

type IntroBannerProps = {
  registrationDate: string,
  currentPage: string,
  clientId: string,
};

function IntroBanner({ registrationDate, currentPage, clientId }: IntroBannerProps) {
  const showNewUISwitchBanner = localStorage.getItem('isNewUISwitchBannerVisible');
  const daysSinceUserWasCreated = differenceInDays(registrationDate, new Date());
  const wasUserCreatedMoreThanFiveDaysAgo = daysSinceUserWasCreated < -5;

  if (!showNewUISwitchBanner || showNewUISwitchBanner !== 'false') {
    return <SwitchBanner clientId={clientId} />;
  }

  if (wasUserCreatedMoreThanFiveDaysAgo || !currentPage || !registrationDate) {
    return null;
  }

  return (
    <Banner localStorageKey={currentPageToLocalStorageKey[currentPage]}>
      <Text>
        <b>{currentPageToBoldBannerText[currentPage]}</b> {currentPageToBannerText[currentPage]}
      </Text>
    </Banner>
  );
}

export default IntroBanner;
